__turbopack_context__.v({
  "chosenEvaluation": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__chosenEvaluation",
  "details": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__details",
  "expanded": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__expanded",
  "impactContext": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__impactContext",
  "impactDetailsDescription": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__impactDetailsDescription",
  "impactDetailsExpandText": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__impactDetailsExpandText",
  "impactOutput": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__impactOutput",
  "overview": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__overview",
  "spacerRow": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__spacerRow",
  "wrapper": "DonationImpactItemGlobalHealth-module-scss-module__QYDAlW__wrapper",
});
